import { render, staticRenderFns } from "./quick-detail.vue?vue&type=template&id=75e91f10&scoped=true&"
import script from "./quick-detail.vue?vue&type=script&lang=js&"
export * from "./quick-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e91f10",
  null
  
)

export default component.exports